import { ModifiersList } from "./fields/modifiers/modifiers-list";
import { GeneralInput } from "./fields/general-input";
import { Ajax } from "../ajax";
import { Notifications } from "../notifications";
export class Save {
    constructor() {
        this.inputs = [];
        this._saving = false;
        this.form = $("#save");
        this.modifiersList = new ModifiersList();
        this.form.on("submit", (event) => event.preventDefault());
        $("#save_submit").on("click", () => this.save());
        this.createInputs();
    }
    createInputs() {
        this.form.find(".save-input").each((index, element) => {
            const input = new GeneralInput($(element));
            this.inputs.push(input);
            this.modifiersList.applyTo(input);
        });
    }
    set saving(value) {
        this._saving = value;
        this.inputs.forEach((input) => (input.disabled = value));
    }
    get saving() {
        return this._saving;
    }
    get url() {
        return this.form.attr("action");
    }
    save() {
        if (this.saving) {
            return;
        }
        this.saving = true;
        const formData = new FormData();
        let inputsRemaining = this.inputs.length;
        this.inputs.forEach((element) => {
            element.addToFormData(formData).then(() => {
                inputsRemaining--;
                if (inputsRemaining === 0) {
                    const ajax = new Ajax(this.url);
                    ajax.data = formData;
                    ajax.successCallback = (data) => this.handleResponse(data);
                    ajax.errorCallback = (data) => this.onError(data);
                    ajax.send();
                }
            });
        });
    }
    handleResponse(data) {
        if (data.error) {
            Notifications.error(data.message);
        }
        else {
            if (data.action === "back") {
                Save.goBack(data);
            }
            else {
                this.resetForm(data);
            }
        }
        this.saving = false;
    }
    resetForm(data) {
        Notifications.success(data.message, data.title);
        this.form.trigger("reset");
    }
    static goBack(data) {
        Notifications.successCookie(data.message, data.title);
        if ("referrer" in document) {
            window.location.href = document.referrer;
        }
        else {
            window.history.back();
        }
    }
    onError(error) {
        if (error.responseJSON) {
            this.handleResponse(error.responseJSON);
        }
        else {
            console.error(error);
            this.saving = false;
        }
    }
}
